export * from './agris-lista-cotizaciones-page.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-lista-cotizaciones-page/index.ts